import { TextSummaryBase } from "./base"

export class ForecastTextSummary extends TextSummaryBase {
  static cssClass = "forecast-text-summary"
  protected readonly urlDatasetKey = "forecastTextSummaryUrl"
  protected readonly containerDatasetFlag = "forecastTextSummaryContainer"
}
